/**
 * Injects a `script` element into the `head` section of the document,
 * pointing to the url specified.
 * @param url The URL fro m which to load the script.
 * @param [options.async=true] Indicates that the script should be
 * executed asynchronously.
 * @param [options.onError] The callback to call on failure to load.
 * @param [options.onLoad] The callback to call on successful load.
 */
export default function loadScript(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$async = options.async,
      async = _options$async === void 0 ? true : _options$async,
      _options$crossOrigin = options.crossOrigin,
      crossOrigin = _options$crossOrigin === void 0 ? null : _options$crossOrigin,
      onError = options.onError,
      onLoad = options.onLoad;
  var head = document.getElementsByTagName('head')[0];
  var script = document.createElement('script');
  script.type = 'text/javascript';

  if (script.readyState) {
    // Internet Explorer
    if (onLoad) {
      script.onreadystatechange = function handleReadyStateChange() {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          onLoad();
        }
      };
    }
  } else {
    // Others
    if (onLoad) {
      script.onload = function handleLoad() {
        script.onerror = null;
        script.onload = null;
        onLoad();
      };
    }

    if (onError) {
      script.onerror = function handleError() {
        script.onerror = null;
        script.onload = null;
        onError();
      };
    }
  }

  script.src = url;
  script.async = async;
  script.crossOrigin = crossOrigin;
  head.appendChild(script);
  return script;
}
//# sourceMappingURL=loadScript.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/~/@flowio/browser-helpers/dist/esm/loadScript.js
// module id = 577
// module chunks = 0 1